import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { SegmentConnection, SegmentRegion } from '../../connection.models';
import { NotifyService } from '../../../common/services/notify.service';
import { selectConnectionsErrors } from '../../store/connections.selectors';

@Component({
  selector: 'connection-form-segment',
  template: `
    <xp-form-validation type="SegmentDatabaseConnection" [name]="formName">
      <form id="connectionFormSegment" name="connectionFormSegment" #form="ngForm" class="form">
        <div class="row">
          <div class="col-md-6">
            <xp-form-group>
              <label for="name">{{ 'connections.form.mongo.labels.name' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="name"
                id="name"
                [(ngModel)]="connection.name"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <div class="form-group" *ngIf="connection.unique_id">
              <label for="unique_id">{{ 'connections.form.labels.unique_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="unique_id"
                id="unique_id"
                [(ngModel)]="connection.unique_id"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </div>
            <connection-component-access-type
              [connection]="connection"
              (tunnelTypeChange)="onTunnelTypeChange(value)"
            ></connection-component-access-type>
            <xp-form-group class="connection-ssl" [validationDisabled]="true">
              <label for="connection-ssl">
                <xp-input type="checkbox" name="ssl" [(ngModel)]="connection.ssl" id="connection-ssl"></xp-input>
                <span>{{ 'connections.form.labels.connect_using_ssl' | translate }}</span>
              </label>
            </xp-form-group>
          </div>
          <div class="col-md-6">
            <xp-form-group>
              <label for="database"
                >{{ 'connections.form.labels.database' | translate }}
                <span class="text-muted">{{ 'generic.labels.optional' | translate }}</span></label
              >
              <xp-input
                type="text"
                class="form-control"
                name="database"
                id="database"
                [(ngModel)]="connection.database"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <xp-form-group>
              <label for="region">{{ 'connections.form.segment.labels.region' | translate }}</label>
              <xp-select
                class="form-control"
                id="region"
                name="region"
                [value]="connection.region"
                [options]="regionOptions"
                (valueChange)="onRegionChange($event)"
              >
              </xp-select>
            </xp-form-group>
            <connection-component-username-password [connection]="connection"></connection-component-username-password>
          </div>
        </div>
      </form>
    </xp-form-validation>
  `,
})
export class ConnectionFormSegmentComponent extends BaseForm implements BaseFormInterface {
  @Input() connection: Partial<SegmentConnection> = {};
  @Output() formValidationChange = new EventEmitter<boolean>();
  @Output() tunnelTypeChange = new EventEmitter<String>();

  @ViewChild('form') form: NgForm;
  formName = 'connectionFormSegment';
  successMessageText = 'connection.form.success_message';
  errors$ = this.store.select(selectConnectionsErrors);
  errorTexts = [];
  regionOptions = [
    {
      value: SegmentRegion['amazon-web-services::ap-southeast-1'],
      text: 'regions.amazon-web-services::ap-southeast-1.short',
      translate: true,
    },
    {
      value: SegmentRegion['amazon-web-services::ap-southeast-2'],
      text: 'regions.amazon-web-services::ap-southeast-2.short',
      translate: true,
    },
    {
      value: SegmentRegion['amazon-web-services::ap-northeast-1'],
      text: 'regions.amazon-web-services::ap-northeast-1.short',
      translate: true,
    },
    {
      value: SegmentRegion['amazon-web-services::eu-west-1'],
      text: 'regions.amazon-web-services::eu-west-1.short',
      translate: true,
    },
    {
      value: SegmentRegion['amazon-web-services::us-east-1'],
      text: 'regions.amazon-web-services::us-east-1.short',
      translate: true,
    },
    {
      value: SegmentRegion['amazon-web-services::us-west-1'],
      text: 'regions.amazon-web-services::us-west-1.short',
      translate: true,
    },
    {
      value: SegmentRegion['amazon-web-services::us-west-2'],
      text: 'regions.amazon-web-services::us-west-2.short',
      translate: true,
    },
  ];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
    @Inject('$rootScope') private $rootScope: any,
  ) {
    super();
  }

  onRegionChange(region: SegmentRegion) {
    this.connection.region = region;
  }

  onTunnelTypeChange(value: string) {
    this.tunnelTypeChange.emit(value);
  }
}
